import { InfoTip } from './InfoTip'

/** A subsection heading inside a card — the prototype's `.sub-head` (12px,
 * 600, uppercase, tertiary, 12px below) with its optional info glyph opening
 * below the icon, as `subHead(label, info, width)` draws it (MS-820). */
export function SubHead({
  label,
  info,
  infoWidth = 300,
  className = 'mb-3',
}: Readonly<{ label: string; info?: string; infoWidth?: number; className?: string }>) {
  return (
    <div
      className={`flex items-center text-[12px] font-semibold uppercase tracking-[.5px] text-[var(--text-tertiary)] ${className}`}
    >
      {label}
      {info && <InfoTip text={info} placement="below" align="left" width={infoWidth} />}
    </div>
  )
}
